"use client";

import type { Locale } from "@/i18n-config";
import { FooterNavigation } from "@/components/navigation/FooterNavigation";
import { useClientAuth } from "@/components/providers/client/AuthProvider";
import {
  filterNavigation,
  type NavigationItem,
} from "@/utils/content/navigation";

export function PublicFooterNavigation({
  lang,
  navigation,
}: {
  lang: Locale;
  navigation: NavigationItem[];
}) {
  const auth = useClientAuth();
  return (
    <FooterNavigation
      lang={lang}
      navigation={filterNavigation(navigation, {
        ...auth,
        user: auth.user ?? null,
        session: auth.session ?? null,
      })}
    />
  );
}
